import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const Toast = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 99999;
  background-color: ${Variables.colors.black_800};
  padding: 16px;
  border-radius: 4px;
  color: ${Variables.colors.complementary_400};
  display:flex;
  align-items:center;
  i{
    color:${Variables.colors.complementary_500};
    font-size:12px;
    cursor: pointer;
    margin-right:16px;
    margin-top:5px;
  }
`;
